/**
 * countdown.js — đồng hồ đếm ngược của flash sale (mục 20): GIỜ · PHÚT · GIÂY.
 *
 * Markup: [data-countdown][data-end="2026-10-22T23:59:59+07:00"] chứa
 *         [data-countdown-h] [data-countdown-m] [data-countdown-s] (+ [data-countdown-d] tuỳ chọn).
 * Có ô ngày thì giờ chỉ còn phần dư 0–23 (banner deal tháng); không có thì giờ là tổng số giờ.
 * data-end="month" = cuối ngày cuối tháng hiện tại theo giờ máy — bản tĩnh của banner deal tháng
 * lúc nào mở cũng thấy chạy; WP in ngày thật (date_on_sale_to / post meta deal_end).
 * Không có data-end (bản tĩnh) thì đếm tới nửa đêm hôm nay theo giờ máy — để demo
 * lúc nào mở ra cũng thấy chạy. Hết giờ thì dừng ở 00:00:00 và gắn .is-ended để
 * CSS/PHP quyết định ẩn khối hay đổi nhãn.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var timers = [].slice.call(document.querySelectorAll('[data-countdown]'));
    if (!timers.length) return;

    function pad(n) {
        return n < 10 ? '0' + n : String(n);
    }

    timers.forEach(function (el) {
        var attr = el.getAttribute('data-end') || '';
        var end = Date.parse(attr);
        if (attr === 'month') {
            var now = new Date();
            end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999).getTime();
        } else if (isNaN(end)) {
            var midnight = new Date();
            midnight.setHours(23, 59, 59, 999);
            end = midnight.getTime();
        }

        var d = el.querySelector('[data-countdown-d]');
        var h = el.querySelector('[data-countdown-h]');
        var m = el.querySelector('[data-countdown-m]');
        var s = el.querySelector('[data-countdown-s]');
        var timer;

        function tick() {
            var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
            if (d) d.textContent = pad(Math.floor(left / 86400));
            if (h) h.textContent = pad(Math.floor((d ? left % 86400 : left) / 3600));
            if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
            if (s) s.textContent = pad(left % 60);
            if (!left) {
                window.clearInterval(timer);
                el.classList.add('is-ended');
            }
        }

        tick();
        timer = window.setInterval(tick, 1000);
    });
})();
